var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharpOutlineTicket1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.394 11.9734C19.394 13.038 20.2531 13.8897 21.3269 13.8897H21.998V19H15.998H13.998H1.99805V13.943H2.53496C3.60879 13.943 4.46785 13.0913 4.46785 12.0266C4.46785 10.962 3.60879 10.1103 2.53496 10.1103H1.99805V5H22.002V10.057H21.3269C20.2531 10.057 19.394 10.9087 19.394 11.9734ZM13.998 17H3.99805V15.5C5.39402 15.2605 6.46784 13.4753 6.46784 12.0114C6.46784 10.5475 5.39402 8.76616 3.99805 8.5V7H13.998V10H15.998V7H19.998V8.5C18.5484 8.71293 17.4209 10.5209 17.4209 12.038C17.4209 13.5551 18.5484 15.2871 19.998 15.5V17H15.998V16H13.998V17ZM13.998 11H15.998V15H13.998V11Z",
    fill: "#B9BDC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharpOutlineTicket1);
export default __webpack_public_path__ + "static/media/sharp--outline--ticket1.76b7d7a1d0a033ef413a2ba3f8ef4926.svg";
export { ForwardRef as ReactComponent };